module.exports = __webpack_public_path__ + "static/media/general.600794df.svg";